<template>
  <div>
    <p class="font-semibold mb-6 border-b pb-2">
      Invoice ID
      <span class="text-brand font-bold">#{{invoice.id}}</span>
    </p>

    <p class="font-semibold mb-2">Amount Due</p>
    <p class="mb-4">${{invoice.amount_due}}</p>

    <p class="font-semibold mb-2">Billing Date</p>
    <p>{{formatDate(invoice.for_date)}}</p>

    <a
      href="#"
      class="border border-brand p-1 text-white no-underline text-center rounded mt-4 bg-brand hover:bg-white hover:text-brand"
      @click.prevent="viewPayment()"
    >View Payment</a>
    
    <button
      @click.prevent="downloadInvoice()"
      class="border border-brand p-1 text-brand no-underline text-center rounded mt-4 hover:bg-brand hover:text-white"
      :class="{'cursor-not-allowed opacity-75': downloading}"
      :disabled="downloading"
    >
      <span v-if="!downloading">
        <i class="fa fa-download"></i> Download Invoice
      </span>
      <span v-else>Please wait...</span>
    </button>
  </div>
</template>

<script>
export default {
  props: ["subscription-id", "invoice"],

  data() {
    return {
      downloading: false
    };
  },

  methods: {
    downloadInvoice() {
      this.downloading = true;
      axios
        .get(
          `api/users/subscriptions/${this.subscriptionId}/invoices/${
            this.invoice.id
          }/download`,
          {
            responseType: "blob"
          }
        )
        .then(({ data }) => {
          this.downloading = false;
          const url = window.URL.createObjectURL(new Blob([data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `Invoice # ${this.invoice.id}.pdf`); //or any other extension
          document.body.appendChild(link);
          link.click();
        });
    },

    viewPayment() {
      this.$emit("view-payment", this.invoice.id);
    },

    formatDate(date) {
      return moment(date).format("dddd, MMMM Do YYYY");
    }
  }
};
</script>

<style>
</style>
